export const getOS = () => {
    const userAgent = window.navigator.userAgent;
    if (userAgent.includes('Android'))
        return 'Android';
    if (userAgent.includes('iPhone') || userAgent.includes('iPad'))
        return 'iOS';
    if (userAgent.includes('Mac OS X'))
        return 'macOS';
    if (userAgent.includes('Windows'))
        return 'Windows';
    if (userAgent.includes('Linux'))
        return 'Linux';
    return 'Unknown OS';
};
